module.exports = __webpack_public_path__ + "media/fallback/HERO-01-fcbaf19e.jpg";